import * as React from "react"

/**
 * Seven Toolcraft components derive an accessible name from a ReactNode label,
 * and each carried its own byte-identical copy of this walk. One home means a
 * change to the traversal reaches every accessible name at once instead of the
 * six somebody remembered to edit.
 */
export function getReactNodeText(node: React.ReactNode): string {
  if (typeof node === "string" || typeof node === "number") {
    return String(node)
  }

  if (Array.isArray(node)) {
    return node.map(getReactNodeText).join("")
  }

  if (React.isValidElement<{ children?: React.ReactNode }>(node)) {
    return getReactNodeText(node.props.children)
  }

  return ""
}
